<template>
  <div class="main special">
    <div class="nav">
      <div class="left">
        <div @click="$router.go(-1)" class="icon_back"></div>
      </div>
      专题
    </div>
    <div class="content content_main">
      <van-list v-model="loading" :finished="finished" @load="faechPage">
        <van-cell
          v-for="(item, index) in VideoList"
          :key="index"
          class="list_item"
        >
          <div class="list" @click="speCloose(item)">
            <div class="sp_list">
              <div class="sp_img">
                <img :src="item.cover_img || item.vision_img" alt="" />
                <div class="sp_text">
                  <span>{{ item.title }}</span>
                </div>
              </div>
              <div class="sp_desc">
                <p>{{ item.description }}</p>
              </div>
            </div>
          </div>
        </van-cell>
      </van-list>
      <div v-if="!loading && finished" class="No_more">我也是有底线的</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import "../css/special.scss";
export default {
  name: "special",
  data() {
    return {
      VideoList: [],
      listParams: {
        page: 0,
        limit: 5,
      },
      loading: false,
      finished: false,
    };
  },
  watch: {
    $route(to, from) {
      if (to) {
        this.finished = true;
        this.listParams.page = 1;
        this.listParams.limit = 5;
        // 默认清空
        this.VideoList = [];
        this.getAllList();
      }
    },
  },
  computed: {
    ...mapState("userIndex", ["topicList", "specialId"]),
  },
  methods: {
    ...mapActions("userIndex", ["fetchTopicList"]),
    ...mapMutations("userIndex", ["setTopicDetail", "setSpecialId"]),
    getAllList() {
      this.loading = true;
      this.fetchTopicList(this.listParams).then((res) => {
        // console.log(res)
        this.loading = false;
        if (!res || res.data.data.length == 0) {
          this.finished = true;
          return false;
        }
        this.finished = false;
        this.VideoList = res.data.data;
      });
    },
    faechPage() {
      this.listParams.page++;
      this.loading = true;
      this.fetchTopicList(this.listParams).then((res) => {
        this.loading = false;
        if (!res || res.data.data.length == 0) {
          this.finished = true;
          return false;
        }
        this.VideoList = this.VideoList.concat(res.data.data);
      });
    },
    speCloose(item) {
      this.$router.push({
        path: `/specialDesc/${item.id}`,
        query: {
          platform: this.$route.query.platform,
          ver: this.$route.query.ver,
        },
      });
    },
  },
};
</script>
